import isClient from '@equifax-ui/utils/browser/isClient'

export const customPageView = () => {
  isClient() &&
    window.dataLayer.push({
      event: 'CustomPageView'
    })
}
